import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import s from "./ChangePasswordStrongDialog.module.scss";
import OutlinedText from "components/Input/OutlinedText/OutlinedText";
import { validateStrongPassword } from "utils/utils";
import StrongPasswordPopper from "components/StrongPasswordPopper/StrongPasswordPopper";
import { Typography } from "@mui/material";

const DIALOG_LOCALE_KEY = "page.dialogs.changePassword.";

const ChangePasswordStrongDialog = ({ userId, updatePayload, onSubmit }) => {
  const { t } = useTranslation();
  const [focus, setFocus] = useState({});
  const [error, setError] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const INPUT_FIELD_INIT_STATE = {
    id: userId,
    newPassword: "",
  };

  const [fieldInput, setFieldInput] = useState(INPUT_FIELD_INIT_STATE);

  const passwordInputOnChange = (e, field) => {
    const { value } = e.target;
    setError(false);
    setFieldInput({ ...fieldInput, [field]: value });
    if (validateStrongPassword(value)) {
      updatePayload({ ...fieldInput, [field]: value });
    } else {
      updatePayload({ ...fieldInput, [field]: "" });
    }
  };

  const textInputOnFocus = (field) => {
    setFocus({ [field]: true });
  };

  const textInputOnBlur = (field, callback) => {
    if (fieldInput[field] && callback) {
      const isValidValue = callback(fieldInput[field]);
      if (!isValidValue) {
        setError(true);
      }
    }
    setFocus({ [field]: false });
  };

  return (
    <div className={s.contentContainer}>
      <OutlinedText
        type="password"
        label={t(DIALOG_LOCALE_KEY + "newPassword.label")}
        placeholder={t(DIALOG_LOCALE_KEY + "newPassword.placeholder")}
        value={fieldInput.newPassword}
        onEnterDownFn={(e) => {
          e.preventDefault();
          onSubmit && onSubmit();
        }}
        onchangeFn={(e) => passwordInputOnChange(e, "newPassword")}
        onfocusFn={(e) => {
          console.log(e);
          textInputOnFocus("newPassword");
          setAnchorEl(e.target);
        }}
        onblurFn={() => textInputOnBlur("newPassword", validateStrongPassword)}
        sxParams={{
          textFocus: focus.newPassword,
          textError: error,
        }}
        errorMessage={t(DIALOG_LOCALE_KEY + "newPassword.errorInputStrong")}
      />
      <Typography variant="content">
        {t(DIALOG_LOCALE_KEY + "newPassword.requirement.unique")}
      </Typography>
      <StrongPasswordPopper
        open={focus.newPassword}
        anchorEl={anchorEl}
        password={fieldInput.newPassword}
      />
    </div>
  );
};

export default ChangePasswordStrongDialog;
